export default "__VITE_PUBLIC_ASSET__5fe06f9a__"